// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__u_QUd","rootCenter":"LoadMoreObserver_rootCenter__Uo4vi","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__14Hik"};